import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let cached = null;
let inflight = null;
const listeners = new Set();

export async function loadBranding(force = false) {
  if (cached && !force) return cached;
  if (!inflight || force) {
    inflight = axios.get(`${API}/branding`).then((r) => {
      cached = r.data;
      listeners.forEach((fn) => fn(cached));
      applyDocumentIcons(cached);
      return cached;
    }).catch(() => cached).finally(() => { inflight = null; });
  }
  return inflight;
}

function setLink(rel, href) {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) { el = document.createElement("link"); el.rel = rel; document.head.appendChild(el); }
  el.href = href;
}

export function applyDocumentIcons(b) {
  if (!b) return;
  const base = process.env.REACT_APP_BACKEND_URL || "";
  setLink("icon", base + b.favicon);
  setLink("apple-touch-icon", base + b.apple_touch_icon);
  if (b.theme_color) {
    let meta = document.querySelector('meta[name="theme-color"]');
    if (!meta) { meta = document.createElement("meta"); meta.name = "theme-color"; document.head.appendChild(meta); }
    meta.content = b.theme_color;
  }
  if (b.short_name && !document.title.startsWith(b.short_name)) document.title = `${b.short_name} — Super-app`;
}

export const DEFAULT_APP_NAME = "FUTURO PDV";

/** App icon/branding (admin-editable). Returns { has_custom, icon_url, icon_192, favicon } with absolute URLs. */
export function useBranding() {
  const [branding, setBranding] = useState(cached);
  useEffect(() => {
    const fn = (b) => setBranding({ ...b });
    listeners.add(fn);
    loadBranding();
    return () => listeners.delete(fn);
  }, []);
  const base = process.env.REACT_APP_BACKEND_URL || "";
  if (!branding) return { has_custom: false, icon_url: null, icon_192: null, short_name: DEFAULT_APP_NAME, theme_color: "#2563eb", refresh: () => loadBranding(true) };
  return {
    ...branding,
    short_name: branding.short_name || DEFAULT_APP_NAME,
    icon_url: base + branding.icon_url,
    icon_192: base + branding.icon_192,
    refresh: () => loadBranding(true),
  };
}
